import { closeHistory } from '@tiptap/pm/history';
import { type EditorState, NodeSelection, type Transaction } from '@tiptap/pm/state';

/** Move one complete top-level block without replacing the document or losing node attributes. */
export function moveBlock(
  state: EditorState,
  index: number,
  direction: -1 | 1,
): Transaction | null {
  const destination = index + direction;

  if (
    index < 0 ||
    index >= state.doc.childCount ||
    destination < 0 ||
    destination >= state.doc.childCount
  ) {
    return null;
  }

  let from = 0;

  for (let i = 0; i < index; i++) {
    from += state.doc.child(i).nodeSize;
  }

  const node = state.doc.child(index);

  const to =
    direction < 0
      ? from - state.doc.child(destination).nodeSize
      : from + state.doc.child(destination).nodeSize;

  const tr = closeHistory(state.tr)
    .delete(from, from + node.nodeSize)
    .insert(to, node);

  return tr.setSelection(NodeSelection.create(tr.doc, to)).scrollIntoView();
}
